import { render, staticRenderFns } from "./CollapseFAQ.vue?vue&type=template&id=3cab38b7&scoped=true&"
import script from "./CollapseFAQ.vue?vue&type=script&lang=js&"
export * from "./CollapseFAQ.vue?vue&type=script&lang=js&"
import style0 from "./CollapseFAQ.vue?vue&type=style&index=0&id=3cab38b7&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cab38b7",
  null
  
)

export default component.exports